var _defs, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUplLoading(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 26,
    height: 26
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "upl-loading_svg__a",
    x1: 0.5,
    x2: 0.5,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffe078",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffac3c"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#upl-loading_svg__a)",
    d: "M-1986.193-1147.807A12.918 12.918 0 01-1990-1157a12.913 12.913 0 013.807-9.192A12.921 12.921 0 01-1977-1170a2 2 0 012 2 2 2 0 01-2 2h-.054a9.011 9.011 0 00-8.946 9 9.01 9.01 0 009 9 9.011 9.011 0 009-9 2 2 0 012-2 2 2 0 012 2 12.915 12.915 0 01-3.808 9.193A12.914 12.914 0 01-1977-1144a12.917 12.917 0 01-9.193-3.807z",
    transform: "translate(1990 1170)"
  })));
}
export default SvgUplLoading;